import React from "react";

interface LargeModalProps {
    title?: string | React.ReactNode;
    onClose: () => void;
    onConfirm?: () => void;
    children?: React.ReactNode;
}

export const LargeModal = ({ title = "Large modal", onClose, children }: LargeModalProps) => {
    return (
        <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/40 p-4 pt-24">
            <div className="bg-white w-full max-w-7xl rounded shadow-lg">
                {/* Header */}
                <div className="flex justify-between items-center px-4 py-3 border-b border-gray-200">
                    <h3 className="text-lg font-semibold">{title}</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 text-xl leading-none"
                    >
                        &times;
                    </button>
                </div>

                {/* Body */}
                <div>
                    {children}
                </div>

            </div>
        </div>
    );
};